module.exports = __webpack_public_path__ + "media/images/sp/brands/aqua/store_asakusa-0715fc9ceb51850fd44e6d367150cbc4.jpg";